import React from 'react'
import createSvgIcon from '../utilities/createSvgIcon'

export default createSvgIcon(
  <>
    <path d="M9.5 3C11.3167 3 12.8496 3.63372 14.0996 4.90039C15.3663 6.15039 16 7.68333 16 9.5C16 10.2333 15.8837 10.9252 15.6504 11.5752C15.4171 12.2251 15.1001 12.7999 14.7002 13.2998L21 19.5996L19.5996 21L13.2998 14.7002C12.7999 15.1001 12.2251 15.4171 11.5752 15.6504C10.9252 15.8837 10.2333 16 9.5 16C7.68333 16 6.14167 15.375 4.875 14.125C3.625 12.8583 3 11.3167 3 9.5C3 7.68343 3.62513 6.15035 4.875 4.90039C6.14167 3.63372 7.68333 3 9.5 3ZM9.5 5C8.25 5 7.18314 5.44186 6.2998 6.3252C5.43327 7.19183 5 8.25009 5 9.5C5 10.75 5.43314 11.8169 6.2998 12.7002C7.18314 13.5669 8.25 14 9.5 14C10.7499 14 11.8082 13.5667 12.6748 12.7002C13.5581 11.8169 14 10.75 14 9.5C14 8.25 13.5581 7.19186 12.6748 6.3252C11.8081 5.44186 10.75 5 9.5 5Z" />
    <path d="M22 12L24 10L22 8L20 10L22 12Z" />
    <path d="M17 4L19 2L17 -4.76837e-07L15 2L17 4Z" />
    <path d="M3 21L5 19L3 17L1 19L3 21Z" />
  </>,
  'AISearch',
)
